export const LOGO_URL = '/custom/images/logo.png';

export const DATE_FORMATS = {
  DEFAULT: 'yyyy-MM-dd',
  DEFAULT_WITH_TIME: 'yyyy-MM-dd HH:mm',
  TIME: 'HH:mm',
  DATE_WITH_DAY_TEXT: 'yyyy-MM-dd (cccc)',
};

export const DEFAULT_PAGE_SIZE = 30;
export const DEBOUNCE_DELAY_50 = 50;
export const DEBOUNCE_DELAY_200 = 200;

export const FILE_SIZE_5MB = 5 * 1024 * 1024; // 5 MB in bytes
export const FILE_SIZE_100MB = 100 * 1024 * 1024; // 100 MB in bytes
export const FILE_SIZE_150MB = 150 * 1024 * 1024; // 100 MB in bytes
export const FILE_SIZE_50MB = 50 * 1024 * 1024; // 50 MB in bytes
export const FILE_SIZE_25MB = 25 * 1024 * 1024; // 25 MB in bytes
